import React from 'react'
import { browserHistory } from 'dva/router'
import dva from 'dva'

import App from './components/App'

const app = dva({ history: browserHistory, })

app.model(require('./models/question').default)
app.model(require('./models/app').default)
app.model(require('./models/score').default)

app.router(() => <App />)

app.start('#root')



// WEBPACK FOOTER //
// ./src/index.js